export default {
	methods:
	{
		reset()
		{
			this.$emit('reset');
		},
	}
};
